import { type SVGProps } from 'react';

/**
 * Esempio "Numero colonne": campo con valore 2 accanto a un campo con 3 —
 * la riga vale 5 colonne, il campo occupa 2/5.
 * source: widget-config-col-2-3.svg
 */
export function ColSpanExampleTwoThree(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1411.24 204.6"
      width="100%"
      aria-hidden="true"
      {...props}
    >
      {/* Campo con Numero colonne 2 (pieno) */}
      <path fill="#16395e" d="M558.93,0v162.08H0V0h558.93" />
      {/* Campo con Numero colonne 3 (bordo) */}
      <g>
        <rect fill="#fff" x="569.43" y="2.5" width="837.39" height="157.08" />
        <path
          fill="#16395e"
          d="M1404.32,5v152.08h-832.39V5h832.39M1409.32,0h-842.39v162.08h842.39V0h0Z"
        />
      </g>
      {/* Righello delle 5 colonne */}
      <path fill="#b4c4d6" d="M275.46,170.08v34.52H0v-34.52h275.46" />
      <path fill="#b4c4d6" d="M558.93,170.08v34.52h-275.46v-34.52h275.46" />
      <path fill="#b4c4d6" d="M842.39,170.08v34.52h-275.46v-34.52h275.46" />
      <path fill="#b4c4d6" d="M1125.86,170.08v34.52h-275.46v-34.52h275.46" />
      <path fill="#b4c4d6" d="M1409.32,170.08v34.52h-275.46v-34.52h275.46" />
      {/* Cifra "3" */}
      <path
        fill="#16395e"
        d="M969.78,39.22c8.59-3.36,18.18-5.04,28.77-5.04s18.32,2.03,23.17,6.09c4.85,4.06,7.28,10.57,7.28,19.53s-3.59,15.82-10.78,20.58c4.48,2.43,7.68,4.95,9.59,7.56,1.91,2.61,2.87,6.77,2.87,12.46,0,9.99-2.5,17.41-7.49,22.26-4.99,4.85-13,7.28-24.01,7.28-8.12,0-16.66-1.21-25.62-3.64l-4.48-1.12.98-14.7c10.45,1.77,19.23,2.66,26.32,2.66,9.61,0,14.42-4.11,14.42-12.32,0-3.45-1.24-6.21-3.71-8.26-2.47-2.05-5.72-3.08-9.73-3.08h-18.62v-15.96h18.62c3.08,0,5.81-1.31,8.19-3.92,2.38-2.61,3.57-5.51,3.57-8.68,0-6.63-4.62-9.94-13.86-9.94-6.44,0-13.3.65-20.58,1.96l-3.64.56-1.26-14.28Z"
      />
      {/* Cifra "2" */}
      <path
        fill="#fff"
        d="M309.28,128.26h-59.92v-16.38l19.74-20.02c7-7.19,11.88-12.69,14.63-16.52,2.75-3.83,4.13-7.91,4.13-12.25s-1.14-7.4-3.43-9.17c-2.29-1.77-5.53-2.66-9.73-2.66-6.25,0-13.07.56-20.44,1.68l-3.36.42-.98-14.98c9.15-2.8,18.62-4.2,28.42-4.2,19.6,0,29.4,8.82,29.4,26.46,0,6.91-1.49,12.88-4.48,17.92-2.99,5.04-8.4,11.15-16.24,18.34l-16.1,14.56h38.36v16.8Z"
      />
    </svg>
  );
}
